import { DatePreference } from '@npm-client-frontends/client-frontends-shared-types'
import { createGlobalState } from 'react-hooks-global-state'

export type UserAttributes = {
  userDateFormat: DatePreference
  userId: string | null
  userName: string | null
  isNewUIEnabled: string | null
  isIXQueuesEnabled: string | null
  intelOnly: boolean
  isTrial: boolean
  fullAccess: boolean
  isMapViewEnabled: boolean
}

const initialState: UserAttributes = {
  userId: null,
  userName: null,
  isNewUIEnabled: null,
  userDateFormat: DatePreference.DEFAULT,
  isIXQueuesEnabled: null,
  intelOnly: false,
  isTrial: false,
  fullAccess: false,
  isMapViewEnabled: false,
}

const { setGlobalState, getGlobalState } = createGlobalState(initialState)

export const DATE_PREFERENCE_ATTRIBUTE = 'custom:date-preference'
export const NEW_UI_ATTRIBUTE = 'custom:new-ui'
export const IX_QUEUES_ATTRIBUTE = 'custom:ix-preview'
export const INTEL_ONLY_ATTRIBUTE = 'custom:intel-only'
export const INTEL_IS_TRIAL = 'custom:trialist'
export const MAP_VIEW_ATTRIBUTE = 'custom:map-view'

export const setUserAttributes = (userAttributes) => {
  try {
    setGlobalState('userId', userAttributes.sub ?? null)
    setGlobalState('userName', userAttributes.name ?? null)

    const dateFormat =
      (userAttributes[DATE_PREFERENCE_ATTRIBUTE] as DatePreference) ||
      DatePreference.NONE
    setGlobalState('userDateFormat', dateFormat)

    const isNewUIEnabled = userAttributes[NEW_UI_ATTRIBUTE] ?? null
    setGlobalState('isNewUIEnabled', isNewUIEnabled)

    const isIXQueuesEnabled = userAttributes[IX_QUEUES_ATTRIBUTE] ?? null
    setGlobalState('isIXQueuesEnabled', isIXQueuesEnabled)

    const intelOnly = userAttributes[INTEL_ONLY_ATTRIBUTE] === 'true'
    setGlobalState('intelOnly', intelOnly)

    const isTrial = userAttributes[INTEL_IS_TRIAL] === 'true'
    setGlobalState('isTrial', isTrial)

    const isMapViewEnabled = userAttributes[MAP_VIEW_ATTRIBUTE] === 'true'
    setGlobalState('isMapViewEnabled', isMapViewEnabled)
  } catch (error) {
    console.error('Error fetching user attributes', error)
    setGlobalState('userDateFormat', DatePreference.DEFAULT)
  }
}

export const getUserAttributes = (): UserAttributes => ({
  userId: getGlobalState('userId'),
  userName: getGlobalState('userName'),
  isNewUIEnabled: getGlobalState('isNewUIEnabled'),
  userDateFormat: getGlobalState('userDateFormat'),
  isIXQueuesEnabled: getGlobalState('isIXQueuesEnabled'),
  intelOnly: getGlobalState('intelOnly'),
  isTrial: getGlobalState('isTrial'),
  fullAccess: getGlobalState('fullAccess'),
  isMapViewEnabled: getGlobalState('isMapViewEnabled'),
})
